import React, { useEffect } from 'react';
import Button from '../../../components/ui/Button';

const SuccessNotification = ({
  isOpen,
  onClose,
  message,
  changes
}) => {
  // Auto-close after 5 seconds
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        onClose();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        {/* Overlay */}
        <div 
          className="fixed inset-0 transition-opacity bg-black bg-opacity-30"
          onClick={onClose}
        ></div>

        {/* Notification */}
        <div className="inline-block w-full max-w-md p-6 my-8 text-left align-middle transition-all transform bg-white shadow-xl rounded-lg sm:my-16">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-3">
              <div className="flex-shrink-0">
                <svg className="w-8 h-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-foreground">
                Success!
              </h3>
            </div>
            <button
              onClick={onClose}
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div className="space-y-4">
            {/* Success Message */}
            <p className="text-foreground">
              {message}
            </p>

            {/* Changes Summary */}
            {changes && changes?.length > 0 && (
              <div className="space-y-2">
                <h4 className="font-medium text-foreground text-sm">Changes Applied:</h4>
                <div className="bg-green-50 border border-green-200 rounded-lg p-3">
                  <ul className="space-y-1">
                    {changes?.map((change, index) => (
                      <li key={index} className="text-sm text-green-700 flex items-start">
                        <svg className="w-3 h-3 mr-2 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                        {change}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}

            {/* Additional Information */}
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
              <div className="flex items-start space-x-2">
                <svg className="w-4 h-4 text-blue-600 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <div className="text-sm text-blue-800">
                  <p className="font-medium mb-1">What's Next?</p>
                  <ul className="text-xs space-y-1">
                    <li>• Changes have been saved and logged</li>
                    <li>• User notifications have been sent</li>
                    <li>• Updated permissions are now in effect</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Auto-close Timer */}
            <div className="flex items-center justify-between text-xs text-muted-foreground">
              <span>This notification will close automatically</span>
              <div className="flex items-center space-x-1">
                <svg className="w-3 h-3 animate-spin" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
                <span>5s</span>
              </div>
            </div>
          </div>

          {/* Action Button */}
          <div className="flex justify-end mt-6">
            <Button
              onClick={onClose}
              iconName="Check"
              iconPosition="left"
            >
              OK
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessNotification;